import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
import {RbDispatch, RootState} from "../../store";

export const useRbDispatch = () => useDispatch<RbDispatch>();
export const useRbSelector: TypedUseSelectorHook<RootState> = useSelector;
